<template>
  <div class="container">
    <div class="header">月票繳費</div>
  
    <div class="input-container">
      <div class="label-line">
        <span class="right-text">請輸入車牌號碼，以查詢繳費資訊</span>
      </div>
      <div class="input-label">
        <label>車牌號碼 </label>
        <span v-if="registered_lps.length" class="dropdown-trigger" @click.stop="toggleDropdown">選取已登記車號</span>
      </div>
      <div class="input-wrapper">
        <input type="text" :value="carNumber" @input="formatCarNumber" placeholder="輸入車牌號碼" class="input-field" />
        <div v-show="showDropdown" class="dropdown">
          <div class="dropdown-option" v-for="(lp, index) in registered_lps" :key="index" @click="selectLP(lp.lpid)">
            {{ lp.lpid }}
          </div>
        </div>
      </div>
      <div class="button-container">
        <!-- <button @click="cancel" class="cancel-button">取消</button> -->
        <button @click="proceed" class="proceed-button">查詢</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      carNumber: '',
      showDropdown: false
    };
  },
  props: {
    parkingInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters(['registered_lps'])
  },
  methods: {
    formatCarNumber(e) {
      const formatted = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      this.carNumber = formatted;
    },
    proceed() {
      this.$emit('updateState', { key: 'carNumber', value: this.carNumber });
      this.$emit('query-parking-fee');
    },
    cancel() {
      this.carNumber = '';
      this.$emit('cancel-payment');
    },
    toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    },
    selectLP(selected) {
      this.carNumber = selected;
      this.showDropdown = false;
      this.$emit('updateState', { key: 'carNumber', value: selected });
    },
    handleClickOutside(event) {
      if (!this.$el.querySelector('.input-container').contains(event.target)) {
        this.showDropdown = false;
      }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }
};
</script>

<style scoped>
.container {
  width: 100%;
  /* height: px; */
  /* height: 348px; */
  /* border: 1px solid #d3d3d3; */
  /* padding: 20px; */
  margin-top:0px;

  background-color: var(--background-gray);

  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;
  padding-bottom:80px;
}

.header {
  margin: 0px;
  text-align: center;

  font-size: 64px;
  font-weight: 700;

  margin-top: 80px;
  margin-bottom: 30px;
  color: var(--green04);
}

.input-container {
  width: 48%;
  min-width: 560px;
  background-color: white;

  padding: 48px;
  box-sizing: border-box;

  /* align-items: left; */
}

.label-line {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-text {
  font-family: Inter;
  font-size: 28px;
  font-weight: 700;
  line-height: 38.08px;
  text-align: left;

  color: var(--gray15);
}

.right-text {
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  text-align: right;

  color: var(--gray13);
}

.input-label {
  width: 100%;

  font-family: Inter;
  font-size: 20px;
  font-weight: 700;
  line-height: 24px;
  text-align: left;

  color: var(--gray13);

  margin-top: 32px;

  display: flex;
  justify-content: space-between;
}

.input-wrapper {
  position: relative;
}

.input-field {
  width: 100%;
  height: 64px;

  margin-top: 8px;

  border: 1px solid var(--gray06);
  border-radius: 12px;

  padding: 10px 16px 10px 16px;
  gap: 10px;
  box-sizing: border-box;

  font-family: Inter;
  font-size: 18px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;

  color: var(--gray15);
}

.button-container {
  display: flex;
  justify-content: center;
  margin-top: 20px;
  gap: 24px;
}

.cancel-button {
  width: 100px;
  height: 58px;
  min-height: 48px;
  padding: 16px 32px 16px 32px;
  border-radius: 99px;

  background-color: white;
  color: var(--green03);

  /* shadow */
  border: none;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);

  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 26.1px;
  text-align: center;
}

.proceed-button {
  width: 100px;
  height: 58px;
  min-height: 48px;
  padding: 16px 32px 16px 32px;
  border-radius: 99px;

  background-color: var(--green03);
  color: white;

  /* shadow */
  border: none;

  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 26.1px;
  text-align: center;
}

.dropdown {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  border: 1px solid #ccc;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  z-index: 1000;
  max-height: 150px;
  overflow-y: auto;
}

.dropdown-option {
  padding: 8px;
  cursor: pointer;
}

.dropdown-option:hover {
  background-color: #f0f0f0;
}

.dropdown-trigger {
  cursor: pointer;
  font-size: 18px;
  color: var(--green03);
  padding: 2px 5px;
  border: 1px solid transparent;
  border-radius: 3px;

  /* no text wrap */
  white-space: nowrap;
}

.dropdown-trigger:hover {
  border-color: var(--green03);
}

/* Responsive Styles for Screens < 560px */
@media (max-width: 560px) {
  .container {
    margin-top: 0px;
  }

  .header {
    margin-top: 40px;
    margin-bottom: 20px;
    font-size: 32px;
    line-height: 43.52px;
  }

  .input-container {
    width: 343px;
    height: 260px;
    border-radius: 20px;
    padding: 20px;
    min-width: unset; /* Override min-width */
    /* width: 100%; Ensure it fits smaller screens */
    box-sizing: border-box;
  }

  .label-line {
    flex-direction: column;
    align-items: flex-start;
  }

  .left-text {
    font-size: 20px;
  }

  .right-text {
    font-size: 14px;
    margin-top: 4px;
  }

  .input-label {
    font-size: 14px;
    margin-top: 24px;
  }

  .input-field {
    height: 48px;
    margin-top: 6px;
  }

  .cancel-button,
  .proceed-button {
    font-size: 14px;
    padding: 10px 20px;
  }

  /* Optional: Adjust button container gap for smaller screens */
  .button-container {
    gap: 16px;
  }


  
.dropdown-trigger {
  cursor: pointer;
  font-size: 16px;
  color: var(--green03);
  padding: 2px 5px;
  border: 1px solid transparent;
  border-radius: 3px;

  /* no text wrap */
  white-space: nowrap;
}

}
</style>
